export default {"src":"/login-app/[GIT_HASH]/_next/static/media/double_check.273ced8b.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};